<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
import { MonthDayReport } from "@/types/calculators";
import TopDayCard from "@/views/Calculators/PersonalDates/components/monthReport/TopDayCard.vue";
import { useI18n } from "vue-i18n";

defineProps<{
  topDays: MonthDayReport[];
}>();

const emit = defineEmits<{
  (e: "selectDay", selectedDay: MonthDayReport): void;
}>();

const { t } = useI18n();
</script>

<template>
  <div
    class="bg-white rounded-2xl border border-divider p-4 sm:p-6 shadow-sm space-y-4"
  >
    <div
      class="flex flex-col sm:flex-row sm:items-center justify-between gap-2"
    >
      <div>
        <h2
          class="text-base sm:text-lg font-bold text-brown flex items-center gap-2"
        >
          <span class="text-gold">★</span>
          <span>
            {{ t("calculators.personal-date.top-days.title") }}
          </span>
        </h2>
        <p class="text-xs text-alternative-gray">
          {{ t("calculators.personal-date.top-days.desc") }}
        </p>
      </div>
    </div>
    <div
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3"
    >
      <TopDayCard
        v-for="(dayReport, index) in topDays"
        :key="dayReport.date"
        :dayReport="dayReport"
        :dayIndex="index"
        @click="emit('selectDay', dayReport)"
      />
    </div>
  </div>
</template>
